import { setLocalInfo, getLocalInfo } from '../../util'

const state = {
  goToUrl: 'home'
}

try {
  let localUrl = getLocalInfo('goToUrl')
  if (localUrl) {
    state.goToUrl = localUrl
  }
} catch (e) { }

const mutations = {
  setGoToUrl (state, data) {
    state.goToUrl = data
    setLocalInfo('goToUrl', data)
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sys.js